import React, { PureComponent } from 'react';
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";

import CarouselImageCardContent from './CarouselImageCardContent';

const useStyles = makeStyles((theme) => ({
    item: {
        float: 'left',
        position: 'relative',
        transitionProperty: 'transform',
    },
}));

class CarouselImageItem extends PureComponent {
    render() {
        const {
            classes, data, parentEntry, link, externalLink, imageType,
            deviceSize, manager, sliderItem, duplicate,
        } = this.props;
        return (
            <div className={classes.item}>
                <CarouselImageCardContent
                    data={data}
                    parentEntry={parentEntry}
                    link={link}
                    externalLink={externalLink}
                    imageType={imageType}
                    deviceSize={deviceSize}
                    manager={manager}
                    sliderItem={sliderItem}
                    duplicate={duplicate}
                />
            </div>
        );
    }
}

CarouselImageItem.prototypes = {
    data: PropTypes.object.isRequired,
    parentEntry: PropTypes.object,
    link: PropTypes.string,
    externalLink: PropTypes.string,
    imageType: PropTypes.string,
    deviceSize: PropTypes.string,
    manager: PropTypes.object,
    sliderItem: PropTypes.number,
    duplicate: PropTypes.bool,
};

export default function _CarouselImageItem(props) {
    const classes = useStyles();
    return <CarouselImageItem {...props} classes={classes} />
}

